import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("none");

  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();

    // ❄️ Hiver = neige (décembre, janvier, février) 
    if (month === 12 || month === 1 || month === 2) { 
      setTheme("snow"); 
    }

    // 🎃 Octobre → Halloween
    else if (month === 10) {
      setTheme("halloween");
    }

    // 🌸 Avril → printemps
    else if (month === 4) {
      setTheme("spring");
    }

    // 🎆 Nouvel an → 31 décembre et 1er janvier
    else if ((month === 12 && day === 31) || (month === 1 && day === 1)) {
      setTheme("newyear");
    }

    // Sinon → aucun thème
    else {
      setTheme("none");
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
